// src/components/TrmValue.jsx
import { useEffect, useState } from "react";
import axios from "axios";

// Función para formatear TRM sin decimales
const formatTRM = (valor) => {
  return valor.toLocaleString("es-CO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
};

const TrmValue = () => {
  const [trm, setTrm] = useState(null);

  useEffect(() => {
    const fetchTRM = async () => {
      try {
        const res = await axios.get("https://api.vintagepro.app/destacados/trm");
        setTrm(res.data.trm);
      } catch (error) {
        console.error("Error al obtener TRM:", error);
      }
    };
    fetchTRM();
  }, []);

  if (!trm) {
    return (
      <span className="trm-value trm-loading" aria-live="polite">
        <span className="trm-icon" aria-hidden="true">💵</span>
        <span className="trm-label">TRM</span>
        <span className="trm-amount">Cargando...</span>
      </span>
    );
  }

  return (
    <span className="trm-value" aria-live="polite">
      <span className="trm-icon" aria-hidden="true">💵</span>
      <span className="trm-label">TRM</span>
      <span className="trm-amount">{formatTRM(trm)} COP</span>
    </span>
  );
};

export default TrmValue;
